
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { ProcessoArquivo } from '@app/models/processo-arquivo.model';

@Injectable()
export class ProcessoArquivoService extends ServiceBase {
  constructor(
    private http: HttpClient,
  ) {
    super();
  }
  // solicitarArquivo(processoId: number) {
  //   return this.http.post(this.URL_API + "ProcessoArquivo/SolicitarArquivo", processoId)
  //     .catch((error: any) => Observable.throw(error.json()));
  // }

  obterProcessoResumo(ficha: string): Observable<any> {
    return this.http.post<any>(this.URL_API + "processos/solicitacoes-pastas/obterProcessoResumo", ficha).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  encaminharPasta(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processos/solicitacoes-pastas/EncaminharPasta/${id}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  encaminharPastaPorFicha(funcionarioId: number, ficha: string): Observable<any> {
    const dados = { funcionarioId, ficha };
    return this.http.post<any>(this.URL_API + `processos/solicitacoes-pastas/EncaminharPasta/`, dados).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  // devolverPasta(id: number) {
  //   return this.http.put(this.URL_API + `processoArquivo/Devolver/${id}`)
  //     .catch((error: any) => Observable.throw(error.json()));
  // }


  cancelar(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processos/solicitacoes-pastas/Cancelar/${id}`);
  }

  // obterPorId(id: number) {
  //   return this.http.get(this.URL_API + `ProcessoArquivo/${id}`);
  // }

  // obterPorProcesso(id: number) {
  //   return this.http.get(this.URL_API + `ProcessoArquivo/ObterPorProcesso/${id}`);
  // }

  obterSolicitacoesPastas(): Observable<any> {
    return this.http.get<any>(this.URL_API + `processos/solicitacoes-pastas/SolicitacoesPastas`);
  }

  obterPastasForaDoArquivo(): Observable<any> {
    return this.http.get<any>(this.URL_API + `processos/solicitacoes-pastas/ObterPastasForaDoArquivo`);
  }



  // obterTodos() {
  //   return this.http.get(this.URL_API + `ProcessoArquivo`);
  // }
}